import { render } from "./LightToDark.vue?vue&type=template&id=5eb8e894"
import script from "./LightToDark.vue?vue&type=script&lang=js"
export * from "./LightToDark.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/MACOS-START/Projet-RegionPoleEmploi/Appli TESTEURS/TESTEURS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__